import { abortFetchSectionsRequests } from 'core/api/middlewares/requestFormatterMiddleware';
import { loadingPage } from 'core/redux/actions/page/pageActions';
import { loggingOutUser } from 'core/redux/actions/user/userActions';
import type { AnyAction,Middleware } from 'redux';

const requestMiddleware: Middleware = () => (next) => (action: AnyAction) => {
  // When browsing pages, some sections might not have been loaded from the previous page.
  // Abort all previous requests to avoid react errors on unmounted components.
  if (loadingPage.match(action) || loggingOutUser.match(action)) {
    abortFetchSectionsRequests();
  }

  next(action);
};

export default requestMiddleware;
